import { render, staticRenderFns } from "./AttachCluster.vue?vue&type=template&id=37163c5e"
import script from "./AttachCluster.vue?vue&type=script&lang=js"
export * from "./AttachCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports